/**
 * <s-free-shipping-popup> — shows the non-modal free-shipping <dialog> on product pages
 * after a short delay. Independent from the gift and warranty pop-ups: it appears on every
 * eligible product page open, and waits for the 18+ confirmation first.
 */
class SFreeShippingPopup extends HTMLElement {
  #ac;
  #timer;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    this.#ac = new AbortController();

    if (this.hasAttribute('data-design-mode')) {
      dialog.show();
      return;
    }

    const delay = Number(this.dataset.delay || 2) * 1000;
    const start = () => {
      this.#timer = setTimeout(() => { if (!dialog.open) dialog.show(); }, delay);
    };

    let ageVerified = false;
    try { ageVerified = localStorage.getItem('ageVerified') === 'true'; } catch (e) { ageVerified = true; }
    if (ageVerified) start();
    else document.addEventListener('age-gate:verified', start, { once: true, signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    clearTimeout(this.#timer);
  }
}

if (!customElements.get('s-free-shipping-popup')) customElements.define('s-free-shipping-popup', SFreeShippingPopup);
